







































import MHeader from "@/components/utility/mmmint/MHeader.vue";
import { IControlElements } from "@/components/utility/TableWrapper.vue";
import PaginatedTable from "@/components/utility/v2/PaginatedTable.vue";
import LayoutReportWithBanner from "@/layouts/LayoutReportWithBanner.vue";
import { IBreadcrumb } from "@/lib/interfaces/utility/breadcrumb-interface";
import { formatCurrency } from "@/lib/utility/currency-helper";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { downloadUrlFromRemoteOrigin } from "@/lib/utility/downloadFileFunc";
import { $t } from "@/lib/utility/t";
import { PageFilterElement } from "@/models/page-filter-element.entity";
import invoiceFleetService from "@/services/mrfiktiv/services/fleet/invoiceFleetService";
import { MrfiktivInvoiceViewModelGen } from "@/services/mrfiktiv/v1/data-contracts";
import { AnalyticsFleetModule } from "@/store/modules/fleet/analytics-fleet.store";
import { InvoiceFleetModule } from "@/store/modules/fleet/invoice-fleet.store";
import { FleetManagerModule } from "@/store/modules/fleet/manager-fleet.store";
import { UserModule } from "@/store/modules/me-user.store";
import { ReportModule } from "@/store/modules/report.store";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    LayoutReportWithBanner,
    PaginatedTable,
    MHeader
  },
  filters: {
    simpleDoubleDigitDate
  }
})
export default class FleetVehicleView extends Vue {
  readonly store = InvoiceFleetModule;

  readonly formatCurrency = formatCurrency;

  isLoading = false;
  selectedId: string | null = null;

  get breadCrumbs(): IBreadcrumb[] {
    const breadCrumbs: IBreadcrumb[] = [];

    breadCrumbs.push({
      text: this.$t("nav.FleetTableView.description"),
      disabled: false,
      exact: true,
      to: {
        name: "FleetAnalyticsView",
        params: {}
      }
    });

    breadCrumbs.push({
      text: this.$t("report.thgBillingOverview.title"),
      disabled: false,
      exact: false,
      to: {
        name: "FleetInvoiceView",
        params: {}
      }
    });

    return breadCrumbs;
  }

  get partnerId() {
    return ReportModule.partner.id;
  }

  get fleetIds() {
    return UserModule.fleetPermission?.filter(p => p.partnerId === this.partnerId).map(p => p.fleetId);
  }

  get fleetId() {
    return FleetManagerModule.selectedFleetId;
  }

  get damageTypeSubtotalData() {
    return AnalyticsFleetModule.damageTypeSubtotalOutboundData;
  }

  get items() {
    return InvoiceFleetModule.filteredAndSorted;
  }

  get headers() {
    return [
      {
        text: $t("objects.invoice.createdOn"),
        align: "left",
        width: 120,
        value: "timestamp.created"
      },
      {
        text: $t("objects.report.claimNumber"),
        align: "left",
        value: "report.claimNumber"
      },
      {
        text: $t("objects.report.numberplate"),
        align: "left",
        value: "report.numberplate"
      },
      {
        text: $t("objects.invoice.number"),
        align: "left",
        value: "number"
      },
      {
        text: $t("objects.invoice.date"),
        align: "left",
        type: Date,
        value: "date"
      },
      {
        text: $t("objects.invoice.due"),
        align: "left",
        type: Date,
        value: "due"
      },
      {
        text: $t("objects.invoice.subTotal"),
        align: "left",
        value: "subTotal"
      },
      { text: "", value: "controls", align: "right", sortable: false }
    ];
  }

  get controlElements(): IControlElements[] {
    const controlElements: IControlElements[] = [
      {
        icon: "mdi-download",
        text: this.$t("download").toString(),
        action: async (selectedItem: MrfiktivInvoiceViewModelGen) => {
          if (!this.fleetId) {
            return;
          }

          const invoice = await invoiceFleetService.findOne(selectedItem.partnerId, this.fleetId, selectedItem.id);

          if (!invoice.data.document?.url) {
            return;
          }

          await downloadUrlFromRemoteOrigin(invoice.data.document.url, `${selectedItem.number}.pdf`);
        }
      }
    ];

    return controlElements;
  }

  mounted() {
    const reportId = this.$route.query["reportId"] as string;

    if (reportId) {
      this.store.setFilters([new PageFilterElement({ key: "reportId", operation: "$eq", value: reportId })]);
    }
  }
}
